// frontend/src/pages/iqgames/fanratings/FanRatingsRankings.jsx

import React, { useEffect, useState } from "react";
import useFanRatingsHook from "./useFanRatingsHook";

const FanRatingsRankings = ({ onBack, question }) => {
  const { getRankings } = useFanRatingsHook();

  const [loading, setLoading] = useState(true);
  const [rankings, setRankings] = useState([]);

  useEffect(() => {
    loadRankings();
  }, []);

  const loadRankings = async () => {
    try {
      setLoading(true);

      const response = await getRankings(question?._id);

      if (response?.success) {
        setRankings(response.data || []);
      } else {
        setRankings([]);
      }
    } catch (error) {
      console.error("FanRatings Rankings Error:", error);
      setRankings([]);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="py-16 text-center">
        <p className="text-gray-50 text-sm">Loading rankings...</p>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-purple-950 p-4">
      <button
        onClick={onBack}
        className="mb-4 rounded-lg bg-fuchsia-700 hover:bg-fuchsia-600 text-white text-xs w-fit px-4 py-2"
      >
        ← Back
      </button>

      <div className="rounded-xl bg-purple-900 border border-fuchsia-700 p-5">
        <h1 className="text-xl font-bold text-gray-50">🏆 Fan Rankings</h1>

        <p className="text-xs text-gray-100 mt-2">
          {question?.title || "Community powered ranking leaderboard"}
        </p>
      </div>

      <div className="mt-5 space-y-4">
        {rankings.map((player, index) => (
          <div
            key={player.name}
            className={`rounded-xl border p-4 ${
              // player.rank === 1
              index === 0
                ? "bg-yellow-900/30 border-yellow-500"
                : "bg-purple-900 border-fuchsia-700"
            }`}
          >
            <div className="flex items-center gap-4">
              <div
                className={`h-12 w-12 rounded-full flex items-center justify-center text-xl font-bold ${
                  // player.rank === 1
                  index === 0
                    ? "bg-yellow-500 text-black"
                    : "bg-fuchsia-800 text-white"
                }`}
              >
                {index < 3 ? ["🥇", "🥈", "🥉"][index] : index + 1}
              </div>

              <div className="flex-1">
                <h3 className="text-sm font-bold text-gray-50">
                  {player.name}
                </h3>

                <p className="text-xs text-gray-100">{question.category}</p>
              </div>

              <div className="text-right">
                <p className="text-yellow-400 font-bold">
                  ⭐ {player.average}
                </p>

                <p className="text-[11px] text-gray-100">
                  {player.votes.toLocaleString()} votes
                </p>
              </div>
            </div>

            <div className="mt-4">
              <div className="flex justify-between text-[11px] text-gray-100 mb-1">
                <span>Fan Score</span>

                <span>{player.averageRating}/10</span>
              </div>

              <div className="h-2 bg-purple-950 rounded-full overflow-hidden">
                <div
                  className="h-full bg-fuchsia-400 rounded-full"
                  style={{
                    width: `${player.rating * 10}%`,
                  }}
                />
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default FanRatingsRankings;
